module.exports = __webpack_public_path__ + "img/linen.be5030ca.webp";